import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, Container, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import '../App.css';
import Navbar from '../Components/Navbar';
import * as API from "../External/APIcalls";
import { formatToPrice } from "../External/GeneralFunctions";
import { useCookies } from 'react-cookie';
import mainTheme from "../Themes";
import BasicCollapsibleTable from '../Components/BasicCollapsibleTable';
import SearchBar from '../Components/SearchBar';
import Footer from '../Components/Footer';
import { DataGrid } from '@mui/x-data-grid';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  LensTwoTone,
} from '@mui/icons-material';
import BasicTable from '../Components/BasicTable';

// Calculate the current year
const currentYear = new Date().getFullYear();

// Generate an array of years from 2023 to the current year
const years: any[] = [];
for (let year = 2023; year <= currentYear; year++) {
  years.push(year);
}
years.reverse();

const getData = async (auth: string) => {
    const headers = {
      "Content-Type": "application/json",
      "X-API-Key": auth
    }
    
    const response = await fetch("https://vmi2.innospecportal.com/api/inventory/", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          "region": "us"
        })
    });
    
    if (!response.ok) {
        console.error("RESPONSE NOT OK! " + response.statusText);
    	return [];
    }

    return await response.json();
}

const getDataSuperAdmin = async (auth: string, id: string) => {
    const headers = {
      "Content-Type": "application/json",
      "X-API-Key": auth
    }
    
    const response = await fetch("https://vmi2.innospecportal.com/api/inventory/", {
        method: "POST",
        headers: headers,
	      body: JSON.stringify({
	        "idCustomer": id,
          "region": "us"
	      })
    });
    
    if (!response.ok) {
        console.error("RESPONSE NOT OK! " + response.statusText);
    	return [];
    }

    return await response.json();
}

let dataList: any[];

function App() {
  const [cookies] = useCookies(["authKey", "userId", "userStatus"]);
  const [userId, setUserId] = useState<string>("");
  const [searchQueryTerm, setSearchQueryTerm] = useState<string>("");
  const [searchQueryStat, setSearchQueryStat] = useState<string>("");
  const [searchQueryProd, setSearchQueryProd] = useState<string>("");
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [orderBy, setOrderBy] = useState<string>('');
  const [summaryOriginal, setSummaryOriginal] = useState<any[]>([]);
  const [summaryFiltered, setSummaryFiltered] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
  const [updatedTimestamp, setUpdatedTimestamp] = useState<string>("");
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);
  const [allCustomersList, setAllCustomersList] = useState<any[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<any>({ id: "none", name: "None" });

  // Helper function to convert price strings to numbers
  const priceStringToNumber = (priceString: string): number => {
    return parseFloat(priceString.replace(/[$,]/g, ''));
  };

  // In-Scope functions
  const performSearch = () => {
    const hasSearch =
      searchQueryTerm !== "" || searchQueryStat !== "" || searchQueryProd !== "";
  
    if (hasSearch) {
      const filteredData = summaryOriginal.filter(element => {
        const terminalMatch = element.fieldData.nameTerminal
          ?.toLowerCase()
          .startsWith(searchQueryTerm.toLowerCase());
  
        const statMatch = element.fieldData.nameState
          ?.toLowerCase()
          .startsWith(searchQueryStat.toLowerCase());
  
        const prodMatch = element.fieldData.productName
          ?.toLowerCase()
          .startsWith(searchQueryProd.toLowerCase());
  
        return (
          (searchQueryTerm === "" || terminalMatch) &&
          (searchQueryStat === "" || statMatch) &&
          (searchQueryProd === "" || prodMatch)
        );
      });
  
      setSummaryFiltered(filteredData);
    } else {
      setSummaryFiltered(summaryOriginal);
    }
  };  

  // Sorting logic
  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    
    const sortedData = [...summaryFiltered].sort((a, b) => {
      const aValue = typeof a.fieldData[property] === 'string' && a.fieldData[property].startsWith('$') ? priceStringToNumber(a.fieldData[property]) : a.fieldData[property];
      const bValue = typeof b.fieldData[property] === 'string' && b.fieldData[property].startsWith('$') ? priceStringToNumber(b.fieldData[property]) : b.fieldData[property];
  
      if (aValue === '?') {
        return 1;
      }
      if (bValue === '?') {
        return -1;
      }
  
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
  
    setSummaryFiltered(sortedData);
  };
  

  // Handlers
  const handleChangeYear = (event: SelectChangeEvent) => {
    setSelectedYear(parseInt(event.target.value as string));
  }

  const handleChangeCustomer = (event: SelectChangeEvent) => {
    for (let i = 0; i < allCustomersList.length; i++) {
      if (allCustomersList[i].name === (event.target.value as string)) {
      	setSelectedCustomer(allCustomersList[i]);
      }
    }
  }

  const handleSearchChangedTerm = (query: string) => {
    setSearchQueryTerm(query);
  }
  const handleSearchChangedStat = (query: string) => {
    setSearchQueryStat(query);
  }
  const handleSearchChangedProd = (query: string) => {
    setSearchQueryProd(query);
  }
  // React effects
  useEffect(() => {
    if (!cookies.authKey || cookies.authKey === "undefined") {
      console.log("No authKey present, kicking user to login screen.");
      window.location.href = "/login";
    }


  }, [cookies]);

  useEffect(() => {
    const fetch = async () => {
      //@ts-expect-error
      document.getElementById("circular-progress-object").style.visibility = "visible";

      try {
        //const user = cookies["userId"];
        //setUserId(user);
	setIsSuperAdmin(cookies["userStatus"] === "Super Admin" || cookies["userStatus"] === "Super%20Admin");
	//@ts-expect-error
	setAllCustomersList(JSON.parse(localStorage.getItem("customerList")));
	//console.log(isSuperAdmin);
	let foundData: any[];
	
	if (isSuperAdmin) {
	    foundData = await getDataSuperAdmin(cookies.authKey, selectedCustomer.id);
	} else {
	    foundData = await getData(cookies.authKey);
	}
        //let manipulatedYearlyData: any[] = foundData;

        //console.log(manipulatedYearlyData);

        //Get timestamp
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        
        // Extract components of the time
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Format the date and time into the desired string format
        const formattedString = `Last Updated on ${month}-${day}-${year} at ${hours}:${minutes}`;

        // Round all floats
        //for (let i = 0; i < foundData.length; i++) {
        //  foundData[i].fieldData.dailyUsage = foundData[i].fieldData.dailyUsage.toFixed(2);
        //}

        // N/A all empty fields
        foundData.forEach(obj => {
          for (let key in obj.fieldData) {
            if (obj.fieldData[key] === "") {
              obj.fieldData[key] = "N/A";
            }
          }
        });

        console.log(foundData);
        
        setUpdatedTimestamp(formattedString);
        setSummaryOriginal(foundData);
        setSummaryFiltered(foundData); // Initially set both states to the fetched data

        /*summaryOriginal.map((row, rowIndex) => {
          console.log(row.fieldData);          
        });*/
        
        //@ts-expect-error
        document.getElementById("circular-progress-object").style.visibility = "hidden";
      } catch (error) {
        console.error('Error fetching:', error);
      }
    }

    fetch();
  }, [selectedCustomer]); // Add selectedYear as a dependency

  useEffect(() => {
    performSearch();
  }, [searchQueryTerm, searchQueryStat, searchQueryProd, summaryOriginal]); // Add searchQuery and summaryOriginal as dependencies

  return (
<div className="App">
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100vw',          // strict viewport width
      overflowX: 'hidden',     // block horizontal scroll
      boxSizing: 'border-box', // include padding/border in width
    }}
  >
    {/* Navbar */}
    <Navbar username="User" />

    {/* Scrollable Content */}
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'auto',
        width: '100%',             // full width
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          width: '100%',
          px: 2,
          py: 1,
          maxWidth: '100vw',       // limit max width strictly
          boxSizing: 'border-box',
        }}
      >
        <Grid
          container
          sx={{
            width: '100%',
            maxWidth: '100%',
            flexWrap: 'wrap',
            gap: 1,
            boxSizing: 'border-box',
          }}
          alignItems="center"
        >
          <SearchBar
            searchLabel="Search by Terminal"
            searchPlaceholder="Search by Terminal..."
            callbackFunction={handleSearchChangedTerm}
          />
          <SearchBar
            searchLabel="Search by State"
            searchPlaceholder="Search by State..."
            callbackFunction={handleSearchChangedStat}
          />
          <SearchBar
            searchLabel="Search by Product"
            searchPlaceholder="Search by Product..."
            callbackFunction={handleSearchChangedProd}
          />
	{isSuperAdmin ?
	<FormControl fullWidth sx={{ maxWidth: "12%", backgroundColor: "#ffffff", mr: 2 }}>
                <InputLabel id="demo-simple-select-label" sx={{color: selectedCustomer.id === "none" ? "red" : ""}}>Select Customer</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedCustomer.name}
                  label="Select Customer"
                  onChange={handleChangeCustomer}
                  size="small" 
                  sx={{ height: "45px" }}
                >
                  {allCustomersList.map((item) => (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
	      : <></>
	}
          <CircularProgress
            sx={{
              transform: 'scale(0.6)',
              visibility: 'visible',
            }}
            id="circular-progress-object"
          />

          <Box
            sx={{
              width: '100%',
              overflowX: 'auto',         // scroll only if table forces it
              boxSizing: 'border-box',
            }}
          >
            <BasicTable
              columns={[
                { id: 'nameTerminal', label: 'Terminal', align: 'left' },
                { id: 'nameState', label: 'State', align: 'left' },
                { id: 'productName', label: 'Product', align: 'left' },
                { id: 'qtyOpening', label: 'Opening', align: 'right' },
                { id: 'qtyUsed', label: 'Used', align: 'right' },
                { id: 'qtyAvailable', label: 'Available', align: 'right' },
                { id: 'dailyUsage', label: 'Daily Usage (7)', align: 'right' },
                { id: 'daysOnHand', label: 'Days On Hand (7)', align: 'right' },
                { id: 'dailyUsage14', label: 'Daily Usage (14)', align: 'right' },
                { id: 'daysOnHand14', label: 'Days On Hand (14)', align: 'right' },
                { id: 'dailyUsage30', label: 'Daily Usage (30)', align: 'right' },
                { id: 'daysOnHand30', label: 'Days On Hand (30)', align: 'right' },
                { id: 'lastReadingDate', label: 'Last Reading Date', align: 'left' },
              ]}
              rows={summaryFiltered}
              maxHeight={"calc(100vh - 150px)"}
              minWidth={0}
              onRequestSort={handleRequestSort}
              order={order}
              orderBy={orderBy}
            />
          </Box>
        </Grid>
      </Box>
    </Box>
    {/*
    <div
      style={{
        height: 50,
        width: '100%',
        backgroundColor: '#FFFFFF',
        padding: 1.5,
        textAlign: 'center',
        boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.1)',
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      <Footer />
    </div>
    */}
  </Box>
</div>


  );
}

export default App;
